import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import Loadable from '@/components/Loadable'

const LinaIntegration = Loadable(
  lazy(() => import('../pages/LinaIntegration/LinaIntegration.page')),
  true,
)

const CustomSpecialties = Loadable(
  lazy(() => import('../pages/CustomSpecialties/CustomSpecialties.page')),
  true,
)

const ChangeHistory = Loadable(
  lazy(() => import('../pages/ChangeHistory/ChangeHistory.page')),
  true,
)

const AppointmentLimitCustom = Loadable(
  lazy(
    () => import('../pages/AppointmentLimitCustom/AppointmentLimitCustom.page'),
  ),
  true,
)

const WhiteLabelConfigs = Loadable(
  lazy(() => import('../pages/WhiteLabelConfigs/WhiteLabelConfigs.page')),
)

const Outcomes = Loadable(
  lazy(() => import('../pages/Outcomes/index')),
  true,
)

const HospitalDigitalPage = Loadable(
  lazy(() => import('../pages/HospitalDigital/HospitalDigital.page')),
  true,
)

const ClinicSchedulePage = Loadable(
  lazy(() => import('../pages/ClinicSchedule/ClinicSchedule.page')),
  true,
)

const ManualFlagsClinica = Loadable(
  lazy(() => import('../pages/ManualFlagsClinica/ManualFlagsClinica.page')),
  true,
)

const ClinicRoutes: RouteObject = {
  path: 'clinica',
  children: [
    {
      path: 'especialidades-customizadas',
      element: <CustomSpecialties />,
    },
    {
      path: 'especialidades-customizadas/historico-alteracoes',
      element: <ChangeHistory />,
    },
    {
      path: 'customizacao-limite-atendimento',
      element: <AppointmentLimitCustom />,
    },
    {
      path: 'customizacao-desfechos',
      element: <Outcomes />,
    },
    {
      path: 'white-label',
      element: <WhiteLabelConfigs />,
    },
    {
      path: 'integracao-lina/:clinicId',
      element: <LinaIntegration />,
    },
    {
      path: 'hospital-digital/:clinicId',
      element: <HospitalDigitalPage />,
    },
    {
      path: 'horarios/:clinicId',
      element: <ClinicSchedulePage />,
    },
    {
      path: 'manual-flags',
      element: <ManualFlagsClinica />,
    },
  ],
}

export default ClinicRoutes
